import {makeStyles} from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root: {

  },
  container: {
    border: `1px solid ${theme.palette.grey.grey100}`,
    background: 'rgba(242, 243, 247, 0.20)',
    margin: '14px 26px',
    padding: '16px',
    maxHeight: '200px',
    overflow: 'auto',
  }
}));

export default useStyles;
